import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-199">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 bg-gradient-to-t from-dark-900 via-dark-900/90 to-transparent pointer-events-none" data-id="element-200">
          <div className="container mx-auto flex justify-center pointer-events-auto" data-id="element-201">
            <Button size="lg" className="w-full md:w-auto shadow-2xl shadow-neon-cyan/50" data-id="element-202">
              QUIERO DOMINAR MI AGARRE
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}